import InputValidator from "./InputValidator";

export default class TypeValidator extends InputValidator {
    constructor(element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, message: string) {
        super(element, message);
    }

    public validate(): boolean {
        this.valid = !this.element.validity.typeMismatch;

        this.emit();

        return this.valid;
    }
}
